import { render, staticRenderFns } from "./SignupConnect.vue?vue&type=template&id=680fb01b&scoped=true&lang=pug&"
import script from "./SignupConnect.vue?vue&type=script&lang=js&"
export * from "./SignupConnect.vue?vue&type=script&lang=js&"
import style0 from "./SignupConnect.vue?vue&type=style&index=0&id=680fb01b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680fb01b",
  null
  
)

export default component.exports